import styled from "styled-components";

import { styles } from "../_Input/Input/styles";

interface IProps {
  verifying?: boolean;
  error?: boolean;
  validate?: boolean;
}

export const Textarea = styled.textarea<IProps>`
  ${styles}

  width: 100%;

  font-family: var(--fontFamily);

  padding: 0.5rem 1rem;

  min-height: 100px;

  resize: vertical;
`;

export const Container = styled.div``;
